"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationAppApiClient = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const errors_1 = require("./errors");
const jwt_1 = require("./jwt");
const query_string_1 = tslib_1.__importDefault(require("query-string"));
const DEFAULT_API_URI = 'https://engine-api.integration.app';
const DEFAULT_UI_URI = 'https://ui.integration.app';
class IntegrationAppApiClient {
    constructor(options) {
        this.init(options);
    }
    init(options) {
        var _a;
        const token = (_a = options.token) !== null && _a !== void 0 ? _a : options.accessToken;
        if (token !== undefined && !(0, jwt_1.isJWT)(token))
            throw new Error('Access token should be a valid JWT token');
        this.apiUri = options.apiUri || DEFAULT_API_URI;
        this.uiUri = options.uiUri || DEFAULT_UI_URI;
        this.token = token;
    }
    async get(uri, queryParams) {
        if (queryParams) {
            uri += `${uri.includes('?') ? '&' : '?'}${new URLSearchParams(queryParams).toString()}`;
        }
        return this.makeApiRequest('GET', { url: uri });
    }
    async post(uri, data) {
        return this.makeApiRequest('POST', { url: uri, data });
    }
    async put(uri, data) {
        return this.makeApiRequest('PUT', { url: uri, data });
    }
    async patch(uri, data) {
        return this.makeApiRequest('PATCH', { url: uri, data });
    }
    async delete(uri) {
        return this.makeApiRequest('DELETE', { url: uri });
    }
    getEmbedUri(page, params) {
        const paramsWithToken = { token: this.token, ...(params !== null && params !== void 0 ? params : {}) };
        const queryParams = query_string_1.default.stringify(paramsWithToken);
        return `${this.uiUri}/embed/${page}${queryParams ? `?${queryParams}` : ''}`;
    }
    async makeApiRequest(method, params = {}) {
        params.method = method;
        params.baseURL = this.apiUri;
        params.headers = {
            ...(params.headers || {}),
            Authorization: `Bearer ${this.token}`,
        };
        let response;
        try {
            response = await axios_1.default.request(params);
        }
        catch (err) {
            this.handleRequestError(err);
        }
        return response.data;
    }
    handleRequestError(err) {
        var _a, _b;
        if (axios_1.default.isAxiosError(err) && ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.type)) {
            const error = (0, errors_1.getErrorFromData)(err.response.data);
            if (error)
                throw error;
        }
        throw err;
    }
}
exports.IntegrationAppApiClient = IntegrationAppApiClient;
//# sourceMappingURL=api-client.js.map